module.exports = require("core-js-pure/stable/instance/bind");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/bind.js
// module id = 6473
// module chunks = 25